import { THETA_MARKETPLACE_WALLET_ADDRESS } from '@wolffun/shared/constants';
import { getCurrentConnector, walletClient } from '@wolffun/shared/src/utils/walletClient';
const address = THETA_MARKETPLACE_WALLET_ADDRESS;
const abi = [{
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: 'uint256',
    name: 'tokenId',
    type: 'uint256'
  }, {
    indexed: false,
    internalType: 'address',
    name: 'nftAddress',
    type: 'address'
  }],
  name: 'CancelSelling',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'address',
    name: 'previousOwner',
    type: 'address'
  }, {
    indexed: true,
    internalType: 'address',
    name: 'newOwner',
    type: 'address'
  }],
  name: 'OwnershipTransferred',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'uint256',
    name: 'tokenId',
    type: 'uint256'
  }, {
    indexed: false,
    internalType: 'uint256',
    name: 'id',
    type: 'uint256'
  }, {
    indexed: false,
    internalType: 'address',
    name: 'contractAddress',
    type: 'address'
  }, {
    indexed: false,
    internalType: 'uint256',
    name: 'price',
    type: 'uint256'
  }, {
    indexed: false,
    internalType: 'address',
    name: 'paymentToken',
    type: 'address'
  }, {
    indexed: false,
    internalType: 'address',
    name: 'seller',
    type: 'address'
  }],
  name: 'SuccessfulSelling',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'uint256',
    name: 'tokenId',
    type: 'uint256'
  }, {
    indexed: false,
    internalType: 'address',
    name: 'contractAddress',
    type: 'address'
  }, {
    indexed: false,
    internalType: 'uint256',
    name: 'price',
    type: 'uint256'
  }, {
    indexed: false,
    internalType: 'address',
    name: 'paymentToken',
    type: 'address'
  }, {
    indexed: false,
    internalType: 'address',
    name: 'seller',
    type: 'address'
  }, {
    indexed: false,
    internalType: 'address',
    name: 'buyer',
    type: 'address'
  }, {
    indexed: false,
    internalType: 'uint256',
    name: 'fee',
    type: 'uint256'
  }],
  name: 'SuccessfullyBuy',
  type: 'event'
}, {
  inputs: [{
    internalType: 'uint256',
    name: '_id',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: '_price',
    type: 'uint256'
  }, {
    internalType: 'address',
    name: '_paymentTokenAddress',
    type: 'address'
  }],
  name: 'buy',
  outputs: [{
    internalType: 'bool',
    name: '',
    type: 'bool'
  }],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'uint256',
    name: '_id',
    type: 'uint256'
  }],
  name: 'cancelSelling',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [],
  name: 'feeToAddress',
  outputs: [{
    internalType: 'address',
    name: '',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'uint256',
    name: '',
    type: 'uint256'
  }],
  name: 'ids',
  outputs: [{
    internalType: 'bool',
    name: '',
    type: 'bool'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'operator',
    type: 'address'
  }, {
    internalType: 'address',
    name: 'from',
    type: 'address'
  }, {
    internalType: 'uint256',
    name: 'tokenId',
    type: 'uint256'
  }, {
    internalType: 'bytes',
    name: 'data',
    type: 'bytes'
  }],
  name: 'onERC721Received',
  outputs: [{
    internalType: 'bytes4',
    name: '',
    type: 'bytes4'
  }],
  stateMutability: 'pure',
  type: 'function'
}, {
  inputs: [],
  name: 'owner',
  outputs: [{
    internalType: 'address',
    name: '',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: '',
    type: 'address'
  }],
  name: 'paymentTokens',
  outputs: [{
    internalType: 'bool',
    name: '',
    type: 'bool'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address[]',
    name: '_removedPaymentTokens',
    type: 'address[]'
  }],
  name: 'removePaymentTokens',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [],
  name: 'renounceOwnership',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'uint256',
    name: '_id',
    type: 'uint256'
  }, {
    internalType: 'address',
    name: '_nftAddress',
    type: 'address'
  }, {
    internalType: 'address',
    name: '_paymentTokenAddress',
    type: 'address'
  }, {
    internalType: 'uint256',
    name: '_tokenId',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: '_price',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: '_expiredAt',
    type: 'uint256'
  }, {
    internalType: 'bytes',
    name: '_signature',
    type: 'bytes'
  }],
  name: 'selling',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'uint256',
    name: '',
    type: 'uint256'
  }],
  name: 'sellingBId',
  outputs: [{
    internalType: 'bool',
    name: 'isExist',
    type: 'bool'
  }, {
    internalType: 'address',
    name: 'owner',
    type: 'address'
  }, {
    internalType: 'uint256',
    name: 'price',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: 'tokenId',
    type: 'uint256'
  }, {
    internalType: 'address',
    name: 'paymentToken',
    type: 'address'
  }, {
    internalType: 'address',
    name: 'nftAddress',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: '_feeToAddress',
    type: 'address'
  }],
  name: 'setFeeToAddress',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address[]',
    name: '_paymentTokens',
    type: 'address[]'
  }],
  name: 'setPaymentTokens',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: '_signer',
    type: 'address'
  }],
  name: 'setSigner',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'uint256',
    name: '_transactionFee',
    type: 'uint256'
  }],
  name: 'setTransactionFee',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [],
  name: 'signer',
  outputs: [{
    internalType: 'address',
    name: '',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'transactionFee',
  outputs: [{
    internalType: 'uint256',
    name: '',
    type: 'uint256'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'newOwner',
    type: 'address'
  }],
  name: 'transferOwnership',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'uint256',
    name: '_id',
    type: 'uint256'
  }, {
    internalType: 'address',
    name: '_nftAddress',
    type: 'address'
  }, {
    internalType: 'address',
    name: '_paymentToken',
    type: 'address'
  }, {
    internalType: 'uint256',
    name: '_tokenId',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: '_price',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: '_expiredAt',
    type: 'uint256'
  }, {
    internalType: 'bytes',
    name: '_signature',
    type: 'bytes'
  }],
  name: 'verifySellingSignature',
  outputs: [],
  stateMutability: 'view',
  type: 'function'
}];

const getContract = () => {
  if (walletClient) {
    return getCurrentConnector().getContract({
      address,
      contractInterface: abi
    });
  }

  return undefined;
};

export default {
  address,
  abi,
  getContract
};